import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import PortalPreviewPage from '../pages/PortalPreviewPage';
import PdfPreviewPage from '../pages/PdfPreviewPage';
import OwnerReceiptPreview from '../pages/OwnerReceiptPreview';

/** Developer-only routes — not registered in production builds (see App.js). */
export function getDevRoutes() {
  return (
    <>
      <Route path="/dev/portals" element={<PortalPreviewPage />} />
      <Route path="/dev/pdf" element={<PdfPreviewPage />} />
      <Route path="/dev/pdf-preview" element={<Navigate to="/dev/pdf" replace />} />
      <Route path="/dev/owner-receipt" element={<OwnerReceiptPreview />} />
    </>
  );
}
